import React from "react";

function Suggestion({ suggestions, onClick }) {
	return (
		<>
			<div className="suggestionButtonContainer">
				{/* Single question mark icon at the start */}
				<img src="/images/qmarkIcon.svg" alt="Question Mark Icon" className="qmarkIcon" />

				{/* Mapping over suggestions to create individual buttons */}
				{suggestions.map((suggestion, index) => (
					<button key={index} className="suggestionButton" onClick={() => onClick(suggestion)}>
						{suggestion}
					</button>
				))}
			</div>
		</>
	);
}

export default Suggestion;
